import 'babel-polyfill'
import React from 'react'
import ConnectedRouter from './utils/ConnectedRouter'
import history from './utils/history'
import context from './context'
import { LocalizationLoader } from '@/components/localization'
import { BlockUI } from '@/components/blockUI'
import { GlobalContextProviders } from '@/components/globalContextProviders'
import DocumentTitle from 'react-document-title'
import { AuthProvider } from '@/components/auth/authProvider'
import { SignalrProvider } from '@/components/signalrProvider'
const Routes = context.routes
const Initializer = context.initializer
function App () {
  return (
    <GlobalContextProviders>
      <SignalrProvider>
        <LocalizationLoader>
          <DocumentTitle title='CBI - BSRS'>
            <React.Fragment>
              <BlockUI />
              <ConnectedRouter history={history}>
                <AuthProvider>
                  <Initializer>
                    <Routes />
                  </Initializer>
                </AuthProvider>
              </ConnectedRouter>
            </React.Fragment>
          </DocumentTitle>
        </LocalizationLoader>
      </SignalrProvider>
    </GlobalContextProviders>
  )
}

export default App



// WEBPACK FOOTER //
// ./src/App.js